"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.strings = exports.sortListDescendingByProp = exports.sortListAscendingByProp = exports.safeJSONParse = exports.rejectEmptyValues = exports.objArrayToDict = exports.isNegative = exports.isBlank = exports.flattenObject = exports.filterNull = exports.fillArray = exports.dictToArray = void 0;
var R = _interopRequireWildcard(require("ramda"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
var _fillArray = exports.fillArray = function fillArray(array, length) {
  var filledArray = R.concat(array, R.slice(0, length - array.length, array));
  if (filledArray.length < length) {
    _fillArray(filledArray, length);
  }
  return filledArray;
};
var isBlank = exports.isBlank = function isBlank(p) {
  return R.isNil(p) || R.isEmpty(p);
};
var isNegative = exports.isNegative = function isNegative(p) {
  return R.lt(p, 0) || p[0] === '-';
};
var rejectEmptyValues = exports.rejectEmptyValues = R.reject(isBlank);
var flattenObject = exports.flattenObject = function flattenObject(obj) {
  var _go = function go(obj_) {
    return R.chain(function (_ref) {
      var _ref2 = _slicedToArray(_ref, 2),
        k = _ref2[0],
        v = _ref2[1];
      if (R.type(v) === 'Object' || R.type(v) === 'Array') {
        return R.map(function (_ref3) {
          var _ref4 = _slicedToArray(_ref3, 2),
            k_ = _ref4[0],
            v_ = _ref4[1];
          return ["".concat(k, ".").concat(k_), v_];
        }, _go(v));
      }
      return [[k, v]];
    }, R.toPairs(obj_));
  };
  return R.fromPairs(_go(obj));
};
var strings = exports.strings = function strings(source) {
  return R.values(source).filter(function (item) {
    return typeof item === 'string';
  });
};
var filterNull = exports.filterNull = R.reject(function (item) {
  return R.isNil(item);
});
var safeJSONParse = exports.safeJSONParse = function safeJSONParse(str) {
  try {
    return JSON.parse(str);
  } catch (e) {
    return {};
  }
};
var sortListAscendingByProp = exports.sortListAscendingByProp = R.curry(function (prop, list) {
  if (isBlank(prop) || isBlank(list)) return [];
  return R.sort(R.ascend(R.prop(prop)))(list);
});
var sortListDescendingByProp = exports.sortListDescendingByProp = R.curry(function (prop, list) {
  if (isBlank(prop) || isBlank(list)) return [];
  return R.sort(R.descend(R.prop(prop)))(list);
});
var objArrayToDict = exports.objArrayToDict = function objArrayToDict(list, keyProp) {
  return list.reduce(function (dict, el) {
    return _objectSpread(_objectSpread({}, dict), {}, _defineProperty({}, el[keyProp], el));
  }, {});
};
var dictToArray = exports.dictToArray = function dictToArray(dict) {
  return Object.keys(dict).reduce(function (arr, key) {
    return [].concat(_toConsumableArray(arr), [dict[key]]);
  }, []);
};